// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12xyW","option":"styles_option__VmMRs","selected":"styles_selected__iCdEk"};